import { ClienteLogin, Cliente } from "../../../views/login/cliente_login";
import { HandleError } from "./handleError.component";
import { SessionTokenService } from "./sessionToken.service";
import { SessionStorageService, SessionStorage } from "ngx-webstorage";
import { Injectable } from '@angular/core';

declare var jQuery: any;

@Injectable()
export class ConsultarUsuarioMasivos {
    usuario: ClienteLogin;
    userAUsar: Cliente;
    bandera: boolean;
    maxDateValue: Date;
    minDateValue: Date;
    yearRange: string;
    @SessionStorage("usermasivos")
    userMasivos: any;

    constructor(private sesionStorageService: SessionStorageService, private handleError: HandleError, private sessionTokenService: SessionTokenService) {
    }
    iniciarUsuarioMasivo(): void {
        this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
        this.consultaTodo();
        this.sesionStorageService.observe("usuario").subscribe(v => {
            this.usuario = jQuery.parseJSON(v);
            this.consultaTodo();
        });
    }

    consultaTodo() {
        if (this.usuario == null) {
            let error = { "status": 998, "message": "Acceso denegado" };
            this.handleError.redirectUrl(error)
        }
        this.sessionTokenService.useJwtHelper();
        let usuarioMasivos = jQuery.parseJSON(this.sesionStorageService.retrieve("usermasivos"));
        if (usuarioMasivos == null) {
            this.consularIfUsuarioMasivos();
        }
        this.sesionStorageService.observe("usermasivos").subscribe(v => {
            if (v != null) {
                let usuarioMasivos1 = jQuery.parseJSON(v);
                if (usuarioMasivos1 == null) {
                    this.consularIfUsuarioMasivos();
                }
            }
        });
    }
    consularIfUsuarioMasivos() {
        if (this.usuario != null) {
            if (this.usuario.Masivos != null) {
                this.userMasivos = JSON.stringify(this.usuario.Masivos[0]);
                this.sesionStorageService.store("usermasivos", JSON.stringify(this.usuario.Masivos[0]));
            } else {
                let error = { "status": 998, "message": "Acceso denegado" };
                this.handleError.redirectUrl(error)
            }
        } else {
            let error = { "status": 998, "message": "Acceso denegado" };
            this.handleError.redirectUrl(error)
        }
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/utils/consultarUsuarioMasivos.ts